import React from 'react';

import {
  TpHoverInfo,
  TpHoverRenderContext,
  TpHoverRenderInfo,
  ZoomPanCanvas,
} from '../../zoompan-canvas/ZoomPanCanvas';
import { TpZoomPanelInvPointMapInfo } from '../../zoompan-canvas/zoomPanCanvasHelpers';
import { TpChartProps } from '../interfaces';
import { createDefinition } from './sunBurst.Renderer';
import { TpRectangleSelection } from '../../zoompan-canvas/helpers';
import { TpEnSelectionFilterTypes } from '../../../../data/selection/interfaces';

export function SunBurst({ chartTypeManifest, dataContext, dataBinding, config, widgetContext }: TpChartProps) {
  const {
    definition,
    areaSunBurst,
    dataItemId,
    levels,
    burstRadius,
    hasNumericalColors,
    colorLabel,
    dataTable,
    title,
  } = createDefinition(chartTypeManifest, dataContext, dataBinding, config);
  const levelCount = levels.length;

  function getHoverInfo(
    mappingInfo: TpZoomPanelInvPointMapInfo,
    logicPositX: number,
    logicPositY: number,
    renderPositX: number,
    renderPositY: number,
  ): TpHoverInfo | null {
    const logicRadius = Math.sqrt((logicPositX - 0.5) ** 2 + (logicPositY - 0.5) ** 2);
    const levelIdx = Math.floor((logicRadius / burstRadius) * (levelCount + 0.5) - 0.5);
    if (levelIdx >= 0 && levelIdx < levelCount) {
      const level = levels[levelIdx];
      let angle = Math.atan2(logicPositX - 0.5, logicPositY - 0.5);
      if (angle < 0) angle += 2 * Math.PI;
      for (const segment of level.segments) {
        if (angle >= segment.startAngle && angle <= segment.startAngle + segment.angle) {
          return {
            dataTableId: dataBinding.dataTableId,
            catColumnId: level.colId,
            itemId: segment.key,
          };
        }
      }
    }
    return null;
  }

  function getHoverRenderInfo(hoverInfo: TpHoverInfo, context: TpHoverRenderContext): TpHoverRenderInfo | null {
    if (hoverInfo.dataTableId != dataBinding.dataTableId) return null;
    for (const level of levels) {
      if (level.colId == hoverInfo.catColumnId) {
        const segment = level.segmentMap[hoverInfo.itemId];
        if (!segment) return null;
        const labels: string[] = [segment.fullName, `Count: ${segment.itemCount}`];
        if (hasNumericalColors) labels.push(`Average ${colorLabel}: ${segment.colorNumericalValue}`);
        const radius = ((level.index + 1) / (levelCount + 0.5)) * burstRadius;
        const obj = {
          area: areaSunBurst,
          logicPosX: 0.5 + radius * Math.sin(segment.startAngle + segment.angle / 2),
          logicPosY: 0.5 + radius * Math.cos(segment.startAngle + segment.angle / 2),
          labels: labels,
        };
        return obj;
      }
    }
    return null;
  }

  function onRectangleSelection(rectangleSelection: TpRectangleSelection) {}

  function onItemClicked(itemId: string) {
    let clickedSegment = null;
    for (const level of levels)
      for (const segment of level.segments) if (segment.key == itemId) clickedSegment = segment;
    if (!clickedSegment) return;

    widgetContext.handleUserSelectionAction({
      type: TpEnSelectionFilterTypes.MULTILEVELCAT,
      dataTableId: dataTable.id,
      colIds: levels.map((level) => level.colId),
      key: clickedSegment.key,
      label: clickedSegment.name,
      selectedItemIds: clickedSegment.itemNumbers.map((nr) => dataItemId[nr]),
    });

    // for (const level of levels)
    //   for (const segment of level.segments) {
    //     if (segment.key == itemId) {
    //       const filterAction = {
    //         filterType: 'action',
    //         content: [`${level.columnInfo.name} = ${segment.fullName}`],
    //       };
    //       const selectedItemIds = segment.itemNumbers.map((nr) => dataItemId[nr]);
    //       widgetContext.onItemsSelected(selectedItemIds, filterAction);
    //     }
    //   }
  }

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <ZoomPanCanvas
        definition={definition}
        getHoverInfo={getHoverInfo}
        getHoverRenderInfo={getHoverRenderInfo}
        onRectangleSelection={onRectangleSelection}
        onItemClicked={onItemClicked}
        maxZoomXRelative={30}
        maxZoomYRelative={30}
        widgetContext={widgetContext}
        chartTitleInfo={{
          assetId: dataContext.assetId,
          dataType: chartTypeManifest.id,
          title,
        }}
      />
    </div>
  );
}
